import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./academicYear.css"

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const FinancialYearMaster = () => {
   const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const [yearLabel, setYearLabel] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [financialYearList, setFinancialYearList] = useState([]);
  const [filters, setFilters] = useState({ searchText: "" });

  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  //  FETCH LIST
  const fetchFinancialYears = async () => {
  try {
    setLoading(true);

    const res = await axios.get(`${BASE_URL}/academicYearsList`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setFinancialYearList(res.data.data.academic_years || []);
  } catch (err) {
    console.error("List Error:", err);

    if (
      err.response &&
      (err.response.status === 401 || err.response.status === 422)
    ) {
      localStorage.clear();
      navigate("/suda/login");
    }
  } finally {
    setLoading(false);
  }
};


const theadStyle = {

                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",

  }


  useEffect(() => {
    fetchFinancialYears();
  }, []);

  //  OPEN ADD MODAL
  const openAddModal = () => {
    setIsEdit(false);
    setShowModal(true);

    setYearLabel("");
    setStartDate("");
    setEndDate("");
  };

  //  OPEN EDIT MODAL
  const openEditModal = async (id) => {
  setIsEdit(true);
  setEditId(id);
  setShowModal(true);

  try {
    const res = await axios.post(
      `${BASE_URL}/academicYearsDetails`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const fy = res.data.data.details;

    setYearLabel(fy.year_label);
    setStartDate(fy.start_date);
    setEndDate(fy.end_date);

  } catch (error) {
    console.error("Edit fetch failed:", error);

    if (error.response?.status === 401 || error.response?.status === 422) {
      localStorage.clear();
      navigate("/suda/login");
    }
  }
};


  //===============
  // 🟢 SUBMIT (ADD + UPDATE)
  //===============
  const handleSubmit = async () => {
    if(!yearLabel || !startDate || !endDate){
        Swal.fire("Validation Failed", "All fields are Required", "warning");
        return
    }
    try {
      const payload = {
        year_label: yearLabel,
        start_date: startDate,
        end_date: endDate,
      };

      if (isEdit) {
        const updatePayload = {
            ...payload,
            id: editId
        }
        await axios.post(`${BASE_URL}/academicYearsUpdate`, updatePayload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        Swal.fire("Updated!", "updated successfully", "success");
      } else {
        // ✅ ADD
        await axios.post(`${BASE_URL}/academicYearsAdd`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        Swal.fire("Saved!", "added successfully", "success");
      }

      setShowModal(false);
      fetchFinancialYears();
    } catch (error) {
      console.error("Save Error:", error);

      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 422)
      ) {
        localStorage.clear();
        window.location.href = "/suda/login";
        return;
      }

      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Something went wrong",
        icon: "warning",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };


  const deleteYear = async (id) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This academic year will be permanently deleted!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  try {
    await axios.post(
      `${BASE_URL}/academicYearsDelete`,
      { id },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    Swal.fire("Deleted!", "Deleted successfully", "success");
    fetchFinancialYears();
  } catch (err) {
    console.error("Delete Error:", err);

    if (err.response?.status === 401 || err.response?.status === 422) {
      localStorage.clear();
      window.location.href = "/suda/login";
      return;
    }

    Swal.fire("Error", "Unable to delete academic year", "error");
  }
};


  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>
      {/* FILTER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Academic Year Master
          </h5>
        </div>
        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Year..."
                  value={filters.searchText}
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  onChange={(e) =>
                    setFilters({ ...filters, searchText: e.target.value })
                  }
                />
              </Form.Group>
            </Col>

            {/* ✅ BUTTONS */}
            <Col md={4} className="d-flex gap-3 mt-3">
              {/* SEARCH */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                onClick={fetchFinancialYears}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              {/* RESET */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#E53935",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                onClick={() => {
                  setFilters({ searchText: "" });
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ADD BUTTON */}
      <Button
        className="mb-3 px-4 text-white fw-semibold"
        onClick={openAddModal}
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          border: "none",
          borderRadius: "10px",
          padding: "10px 22px",
          boxShadow: "0 6px 15px rgba(46,125,50,0.4)",
          transition: "0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #1B5E20, #2E7D32)";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 10px 22px rgba(46,125,50,0.55)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #2E7D32, #66BB6A)";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 6px 15px rgba(46,125,50,0.4)";
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Add Academic Year
      </Button>



      {/* ✅ SHOW LOADER WHEN loading = true */}
{loading && (
  <div className="loader-wrapper">
    <div className="blue-spinner"></div>

    <div className="loading-line">
      <div className="loading-progress"></div>
    </div>

    <p className="loading-text">Loading, please wait...</p>
  </div>
)}

{/* ✅ SHOW TABLE ONLY WHEN loading = false */}
{!loading && (
  <Card
    className="mb-4 border-0"
    style={{
      background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
      boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
      overflow: "hidden",
    }}
  >
    <Table bordered hover responsive >
      <thead className="text-white">
        <tr>
          <th style={theadStyle}>
            SL
          </th>
          <th style={theadStyle}>
            Year Label
          </th>
          <th style={theadStyle}>
            Start Date
          </th>
          <th style={theadStyle}>
            End Date
          </th>
          <th style={theadStyle}>
            Action
          </th>
        </tr>
      </thead>

      <tbody>
        {financialYearList.length > 0 ? (
          financialYearList.map((fy, i) => (
            <tr key={fy.id}>
              <td className="text-center">{i + 1}</td>
              <td className="text-center">{fy.year_label}</td>
              <td className="text-center">{fy.start_date}</td>
              <td className="text-center">{fy.end_date}</td>

              <td className="text-center">
                {/* ✅ EDIT */}
                <Button
                  size="sm"
                  className="me-2"
                  style={{
                    background: "#1565C1",
                    border: "none",
                    padding: "6px 10px",
                    boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#0D47A1")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#1565C1")
                  }
                  onClick={() => openEditModal(fy.id)}
                >
                  <i className="fa-solid fa-pen text-white"></i>
                </Button>

                {/* ✅ DELETE */}
                <Button
                  size="sm"
                  style={{
                    background: "linear-gradient(90deg, #E53935, #D32F2F)",
                    border: "none",
                    padding: "6px 10px",
                    boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background =
                      "linear-gradient(90deg, #D32F2F, #B71C1C)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background =
                      "linear-gradient(90deg, #E53935, #D32F2F)")
                  }

                  onClick={() => deleteYear(fy.id)}

                >
                  <i className="fa-solid fa-trash-can text-white"></i>
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5" className="text-center py-3 text-muted">
              No Data Found
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </Card>
)}


      {/* MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "white" }}
        >
          <Modal.Title>
            {isEdit ? "Edit Academic Year" : "Add Academic Year"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Academic Year Label</Form.Label>
            <Form.Control
              type="text"
              placeholder="2024-2025"
              value={yearLabel}
              onChange={(e) => setYearLabel(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button className="btn-success text-white" onClick={handleSubmit}>
            {isEdit ? "Update" : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FinancialYearMaster;
